import { render, staticRenderFns } from "./GoLink.vue?vue&type=template&id=23008e36&"
import script from "./GoLink.vue?vue&type=script&lang=js&"
export * from "./GoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports